<div class="share">
	<div>
		<img *ngIf="frame" src="{{frame}}" alt="" class="img--container">
	</div>
	<div class="share--bar">
		<button routerLink="/thanks" class="button button--white">
			<img src="../../assets/check.png" alt="finalizar-foto">
			Finalizar
		</button>
		<a href="https://{{decodedImageURL}}" download="Día mundial del corazón.png" class="share--link button button--white">
			<img src="../../assets/download.png" alt="descargar-foto">
			Descargar
		</a>
	</div>

</div>
